import React, { useState } from "react";
import { Popover, Grid, TextField, Checkbox, FormControlLabel, Button, MenuItem, Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import SoftButton from "components/SoftComponents/SoftButton";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import moment from "moment";

function FilterPopover({ selected_user, adjustments, setAdjustments, deviceLayout }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const base_startTime = moment().subtract(3, 'year');
  const base_endTime = moment();

  const base_organisations = selected_user.organisations.map((org) => {
    return [org, true];
  });

  const conditionsDict = {
    "vandalised": false,
    "damaged": false,
    "audio": false,
    "power": false,
    "frozen": false,
    "location": false,
    "other": false
  }

  const base_conditions = false;

  const base_statuses = {
    'review': true,
    'inspected': true,
    'unresolved': true,
    'resolved': true
  }

  const [startTime, setStartTime] = useState(adjustments.filter_by == null ? base_startTime : adjustments.filter_by.startTime);
  const [endTime, setEndTime] = useState(adjustments.filter_by == null ? base_endTime : adjustments.filter_by.endTime);
  const [statuses, setStatuses] = useState(adjustments.filter_by == null ? base_statuses : adjustments.filter_by.statuses);
  const [conditions, setConditions] = useState(adjustments.filter_by == null ? base_conditions : adjustments.filter_by.conditions);
  const [organisations, setOrganisations] = useState(adjustments.filter_by == null ? Object.fromEntries(base_organisations) : adjustments.filter_by.organisations);

  // Open the popover when the SoftButton is clicked
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => { setAnchorEl(null); }
  const handleReset = () => {
    setAdjustments({
      ...adjustments,
      filter_by: {
        startTime: base_startTime,
        endTime: base_endTime,
        statuses: base_statuses,
        conditions: base_conditions,
        organisations: Object.fromEntries(base_organisations)
      }
    })

    setStartTime(base_startTime);
    setEndTime(base_endTime);
    setStatuses(base_statuses)
    setConditions(base_conditions);
    setOrganisations(Object.fromEntries(base_organisations));

    setAnchorEl(null);
  }
  const handleApply = () => {
    console.log(startTime, endTime, statuses, conditions, organisations)

    setAdjustments({
      ...adjustments,
      filter_by: {
        startTime,
        endTime,
        statuses,
        conditions,
        organisations
      }
    })

    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);

  return (
    <>
      {window.innerWidth < 768 ? (
        <SoftButton
          size="small"
          onClick={handleClick}
          sx={{ px: 2.5, boxShadow: 0, minWidth: '32px !important', width: '32px !important' }}
        >
          <FilterListIcon fontSize="large" />
        </SoftButton>
      ) : (
        <SoftButton
          size="small"
          onClick={handleClick}
          startIcon={<FilterListIcon fontSize="large" />}
          sx={{ boxShadow: 0 }}
        >
          <SoftTypography variant="button" color="white">Filters</SoftTypography>
        </SoftButton>
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: (theme) => ({
              mt: 1.5,
              overflow: "visible",
              bgcolor: '#fff',
              boxShadow: "0px 8px 16px rgba(0,0,0,0.1)",
              border: "1px solid #e5e7eb",
              p: 2,
              maxWidth: 'min-content',
              [theme.breakpoints.up('md')]: {
                maxWidth: 'fit-content'
              }
            }),
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xxs={12} md={6}>
            <SoftBox display="flex" flexDirection="column">
              <SoftBox pl={1}>
                <SoftTypography variant="caption" fontWeight="bold">Start Date</SoftTypography>
              </SoftBox>
              <SoftBox>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker format="DD/MM/YYYY" value={startTime} onChange={(new_value) => { setStartTime(new_value); }} />
                </LocalizationProvider>
              </SoftBox>
            </SoftBox>
          </Grid>
          <Grid item xxs={12} md={6}>
            <SoftBox display="flex" flexDirection="column" pl={{ xxs: 0, md: 1 }}>
              <SoftBox pl={1}>
                <SoftTypography variant="caption" fontWeight="bold">End Date</SoftTypography>
              </SoftBox>
              <SoftBox>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker format="DD/MM/YYYY" value={endTime} onChange={(new_value) => { setEndTime(new_value); }} />
                </LocalizationProvider>
              </SoftBox>
            </SoftBox>
          </Grid>
        </Grid>
        <SoftBox my={2}>
          <Divider />
        </SoftBox>
        <SoftBox>
          <SoftBox>
            <SoftBox pb={1}>
              <SoftTypography variant="caption" fontWeight="bold">Inspected Conditions</SoftTypography>
            </SoftBox>
            <Grid container spacing={1}>
              {Object.entries(conditionsDict).map(([key, value], index) => (
                <Grid key={index} item xxs={12} md={6} xl={4}>
                  <SoftBox pl={1} display="flex" flexDirection="row" alignItems="center">
                    <Checkbox checked={conditions[key]} onChange={(val) => {
                      // conditions[key] = !conditions[key]
                      // console.log(conditions);
                      if (!conditions) {
                        setConditions({
                          ...conditionsDict,
                          [key]: !conditions[key]
                        });
                      }
                      else {
                        setConditions({
                          ...conditions,
                          [key]: !conditions[key]
                        });
                      }
                    }} />
                    <SoftTypography variant="body3" fontWeight="regular" textTransform="capitalize">{key}</SoftTypography>
                  </SoftBox>
                </Grid>
              ))}
            </Grid>
          </SoftBox>
        </SoftBox>
        <SoftBox my={2}>
          <Divider />
        </SoftBox>
        {/* {selected_user.organisations.length > 1 && (
          <>
            <SoftBox>
              <SoftBox pb={1}>
                <SoftTypography variant="caption" fontWeight="bold">Organisation</SoftTypography>
              </SoftBox>
              <Grid container spacing={1}>
                {selected_user.organisations.map((org, orgIndex) => (
                  <Grid key={orgIndex} item xxs={6} xl={4}>
                    <SoftBox pl={1} display="flex" flexDirection="row" alignItems="center">
                      <Checkbox checked={organisations[org]} onChange={(val) => {
                        // console.log(val)
                        setOrganisations({
                          ...organisations,
                          [org]: !organisations[org]
                        });
                        // organisations[org] = !organisations[org]
                      }} />
                      <SoftTypography variant="body3" fontWeight="regular" textTransform="capitalize">{org}</SoftTypography>
                    </SoftBox>
                  </Grid>
                ))}
              </Grid>
            </SoftBox>
            <SoftBox my={2}>
              <Divider />
            </SoftBox>
          </>
        )} */}
        <SoftBox mt={2} display="flex" justifyContent="flex-start">
          <SoftButton variant="gradient" color="error" onClick={handleReset}>
            Reset
          </SoftButton>
          <SoftButton sx={{ marginLeft: '4px' }} variant="gradient" color="info" onClick={handleApply}>
            Apply
          </SoftButton>
        </SoftBox>
      </Popover>
    </>
  );
}

FilterPopover.propTypes = {
  selected_user: PropTypes.object,
  adjustments: PropTypes.object,
  setAdjustments: PropTypes.func,
  deviceLayout: PropTypes.string,
}

export default FilterPopover;